import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getCurrentUser } from 'selectors/sessionSelectors';
import { MainMenu } from '../mainMenu/MainMenu';

require('./SiteHeader.css');

const logoImgSrc = require('assets/images/mosaicone-logo.png');

export const SiteHeader = () => {
    const isLoggedIn = !!useSelector(getCurrentUser);
    return (
        <div id="site-header">
            <div className="logo-corner">
                <Link to='/'>
                    <img src={ logoImgSrc } alt="MosaicONE"/>
                </Link>
            </div>
            { isLoggedIn &&
                <MainMenu/>
            }
        </div>
    );
};
